import { render, staticRenderFns } from "./Justify.vue?vue&type=template&id=63963e08&scoped=true"
import script from "./Justify.vue?vue&type=script&lang=js"
export * from "./Justify.vue?vue&type=script&lang=js"
import style0 from "./Justify.vue?vue&type=style&index=0&id=63963e08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63963e08",
  null
  
)

export default component.exports